// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Navigation styles */

.nav {
  display: flex;
  list-style: none;
  width: 40vw;
  justify-content: space-between;
}

#nav-link:visited {
  text-decoration: none;
  color: #ebdfcc;
}

#nav-link.active {
  color: #db791a;
  display: flex;
  justify-content: end;
}

#nav-link {
  display: flex;
  justify-content: end;
}

@media (max-width: 589px) {
  .nav {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Navigation/Navigation.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF","sourcesContent":["/* Navigation styles */\n\n.nav {\n  display: flex;\n  list-style: none;\n  width: 40vw;\n  justify-content: space-between;\n}\n\n#nav-link:visited {\n  text-decoration: none;\n  color: #ebdfcc;\n}\n\n#nav-link.active {\n  color: #db791a;\n  display: flex;\n  justify-content: end;\n}\n\n#nav-link {\n  display: flex;\n  justify-content: end;\n}\n\n@media (max-width: 589px) {\n  .nav {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
